import { Switch, Route, useHistory, Redirect } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Login from './Login/Login';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import './App.css';
import { AppContext } from '../../utils/AppContext';
import ResetPassword, { RESET_USER_KEY } from './ResetPassword/ResetPassword';
import PageNotFound from './PageNotFound/PageNotFound';
import useLogRocket from '../../customHooks/useLogRocket';
import useNewrelic from '../../customHooks/useNewRelic';


const App = () => {
  const { backgroundURL, isAppReady, activeConfigurationsURL } = useContext(AppContext);
  const { i18n } = useTranslation();
  const history = useHistory();
  const { startLogRocket } = useLogRocket();
  const { startNewrelic } = useNewrelic();
  document.body.dir = i18n.dir();

  useEffect(() => {
    startLogRocket();
  }, [startLogRocket]);

  useEffect(() => {
    startNewrelic();
  }, [startNewrelic]);

  useEffect(() => {
    if (window.localStorage.getItem(RESET_USER_KEY) && history.location.pathname !== '/reset') {
      history.push(`/reset${window.location.search}`);
    }
  }, [history]);

  return (
    <div>
      <div
        className="background"
        style={backgroundURL ? { backgroundImage: `url(${backgroundURL})` } : {}}
      >
        {isAppReady ? (
          <Switch>
            <Route path="/login" component={Login}></Route>
            <Route path="/forgot" component={ForgotPassword}></Route>
            <Route path="/reset" component={ResetPassword}></Route>
            <Redirect
              from="*"
              to={`/login${
                window.location.search
                  ? `?${new URLSearchParams(window.location.search).toString()}`
                  : ''
              }`}
            ></Redirect>
          </Switch>
        ) : (
          typeof activeConfigurationsURL === 'undefined' && <PageNotFound />
        )}
      </div>
      <div className="footer">
        <img className="footer-logo" src="/Logo.svg" alt="footer-logo"></img>
      </div>
    </div>
  );
};

export default App;
